import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type ConfirmationDialogType = {
  id: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  contentText?: string | null;
};

function ConfirmationDialog({
  id,
  open,
  onClose,
  onConfirm,
  title,
  contentText = "",
}: ConfirmationDialogType) {
  const { t } = useTranslation(["_action"]);
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontSize: "1.2rem" }} data-testid={`${id}-confirmation-dialog-title`}>
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText data-testid={`${id}-confirmation-dialog-contentText`}>
          {contentText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid={`${id}-confirmation-dialog-cancel-btn`}>
          {t("action_cancel", { ns: "_action" })}
        </Button>
        <Button
          color="error"
          onClick={() => {
            onConfirm();
            onClose();
          }}
          data-testid={`${id}-confirmation-dialog-confirm-btn`}
        >
          {t("action_confirm", { ns: "_action" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationDialog;
